import { get, writable } from 'svelte/store';

import { omitMockLightGroupsFromRecord } from 'src/helpers/dev/mock_light_ids';
import { set_groups_data_android } from 'src/services/lists_update_android';
import { set_groups_data_ios } from 'src/services/lists_update_ios';

import { user_data } from 'src/stores/account/user';
import { app, os } from 'src/stores/session/native-bridge';

function create_groups() {
	const { subscribe, set, update } = writable(JSON.parse(localStorage.getItem('groups')) || {});

	return {
		subscribe,
		set,
		update: (new_group) =>
			update((groups) => {
				const existingGroup = groups[new_group.id];
				// Preserve frontend-only `new` flag for pulse animation
				// Prevents socket updates from wiping pulse animation state
				if (existingGroup?.new && !new_group.new) {
					new_group.new = existingGroup.new;
				}
				return { ...groups, [new_group.id]: new_group };
			}),
		clearNewFlag: (id) =>
			update((groups) => {
				if (groups[id]) {
					delete groups[id].new;
				}
				return { ...groups };
			}),
		remove: (id: number) =>
			update((groups) => {
				delete groups[id];
				return groups;
			}),
		reset: () => set({}),
	};
}

export const groups = create_groups();

groups.subscribe((val) => {
	const persistableGroups = omitMockLightGroupsFromRecord(val);
	localStorage.setItem('groups', JSON.stringify(persistableGroups));
	if (get(app) && get(user_data).email) {
		console.log('send list data to native ', 'GROUPS', persistableGroups);
		if (get(os) === 'IOS') {
			set_groups_data_ios(persistableGroups);
		} else {
			set_groups_data_android(persistableGroups);
		}
	}
});
